<template>
  <div>
    <!-- Loading & Error -->
    <vue-element-loading :active="appLoading" :is-full-screen="true" background-color="#FFFFFF" color="#68D389"
      spinner="bar-fade-scale" />
    <ServerError v-if="ServerError" />

    <!-- Snackbar -->
    <v-snackbar v-model="showSnackBar" color="#68D389" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #ffffff">{{ msg }}</span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #ffffff">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>

    <!-- Header & Filters -->
    <v-layout wrap justify-end class="poppinsregular">
      <v-flex xs12 pa-4 align-self-center text-left>
        <span class="poppinsbold" style="font-size: 20px">Accommodation Summary Report</span>
      </v-flex>

      <v-flex xs12 sm6 md4 lg3>
        <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y
          max-width="290px" min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="selectedDate" label="Report Date" outlined dense v-bind="attrs" v-on="on"
              clearable></v-text-field>
          </template>
          <v-date-picker v-model="selectedDate" no-title @input="menu = false"></v-date-picker>
        </v-menu>
      </v-flex>

      <!-- Download PDF Button -->
      <v-flex xs12 sm6 md3 align-self-center v-if="summaryData.length > 0">
        <a target="_blank" :href="pdfDownloadUrl" class="downlink">
          <span style="font-size: 16px; font-family: poppinssemibold; color: #68D389; cursor: pointer;">
            Download PDF
          </span>
        </a>
      </v-flex>
    </v-layout>

    <!-- Report Content -->
    <v-layout wrap fill-height v-if="summaryData" class="poppinsregular">
      <v-flex xs12 pt-4 v-if="summaryData.length > 0">
        <v-layout wrap>
          <v-flex xs12 sm6 md4 lg3 pa-3 v-for="(item, i) in summaryData" :key="i">
            <v-card class="rounded-lg elevation-2" height="100%">
              <v-card-title class="pb-1">
                <span class="poppinssemibold" style="font-size: 18px;">{{ item.progName }}</span>
              </v-card-title>
              <v-card-text>
                <v-list dense class="pa-0">
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Total Rooms</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="font-weight-bold">{{ item.totalRoomsAvailable }}</span>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Occupied Rooms</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="font-weight-bold">{{ item.roomsOccupied }}</span>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Guests Staying</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="font-weight-bold">{{ item.numberOfGuestsStaying }}</span>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Online Bookings</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="font-weight-bold">{{ item.onlineBookingsCounts }}</span>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Reservations</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="font-weight-bold">{{ item.reservationsCounts }}</span>
                    </v-list-item-action>
                  </v-list-item>

                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Remaining Availability</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-chip :color="item.remainingAvailability > 0 ? 'success' : 'error'" small>
                        {{ item.remainingAvailability }}
                      </v-chip>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 py-8 text-center v-else>
        <span style="font-family: poppinsregular; font-size: 18px; color: #666;">
          No accommodation data found for the selected date.
        </span>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,

      selectedDate: new Date().toISOString().substr(0, 10),
      menu: false,
      summaryData: [],
    };
  },

  watch: {
    selectedDate() {
      this.getData();
    },
  },

  beforeMount() {
    // Default to today if not set
    if (!this.selectedDate) {
      this.selectedDate = new Date().toISOString().substr(0, 10);
    }
    this.getData();
  },

  computed: {
    pdfDownloadUrl() {
      return `${this.baseURL}/report/accommodation-summary-pdf?date=${this.selectedDate}`;
    },
  },

  methods: {
    getData() {
      if (!this.selectedDate) return;

      this.appLoading = true;
      axios({
        method: "GET",
        url: "/report/accommodation-summary",
        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          date: this.selectedDate,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status === true) {
            this.summaryData = response.data.data || [];
          } else {
            this.showSnackBar = true;
            this.msg = "Failed to load report";
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.error(err);
          this.showSnackBar = true;
          this.msg = "Error loading accommodation summary";
        });
    },
  },
};
</script>

<style scoped>
.downlink {
  text-decoration: none;
}
</style>